import { NoteSuggestionRefineActions } from "@/components/note/floating-actions/note-suggestion-refine-actions";
import { MemCommonEditorStore } from "@/components/note/store/mem-common-editor-store";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import styled from "@emotion/styled";
import { NoteObservable } from "@/store/note/NoteObservable";
import {
  MDSButton,
  MDSIcon,
  MDSButtonSlotName,
  MDSButtonVariant,
  MDSIconButton,
  MDSIconButtonSize,
  MDSIconKind,
  MDSText,
  MDSTextVariant,
} from "@/mds";

interface NoteSuggestionActionsProps {
  editorStore: MemCommonEditorStore;
}

export const NoteSuggestionActions = observer(function NoteSuggestionActions({
  editorStore,
}: NoteSuggestionActionsProps) {
  const isRefineEnabled =
    editorStore.noteObservable instanceof NoteObservable &&
    !!editorStore.noteObservable.suggestionData;
  const [showRefineInput, setShowRefineInput] = useState(false);

  if (showRefineInput && editorStore.noteObservable instanceof NoteObservable) {
    return (
      <NoteSuggestionRefineActions
        noteObservable={editorStore.noteObservable}
        setShowRefineInput={setShowRefineInput}
      />
    );
  }

  return (
    <StyledContainer>
      <MDSText variant={MDSTextVariant.TextSm}>Edited Note</MDSText>
      <StyledSButton isDisabled={!isRefineEnabled} onClick={() => setShowRefineInput(true)}>
        <MDSIcon slot={MDSButtonSlotName.LeftIcon} kind={MDSIconKind.Sparkle} />
        Refine
      </StyledSButton>
      <StyledSButton
        variant={MDSButtonVariant.Contrast}
        onClick={() => editorStore.closeSuggestion(true)}
      >
        <MDSIcon slot={MDSButtonSlotName.LeftIcon} kind={MDSIconKind.Check} />
        Accept
      </StyledSButton>
      <MDSIconButton
        onClick={() => editorStore.closeSuggestion(false)}
        iconKind={MDSIconKind.Exit}
        size={MDSIconButtonSize.Medium}
      />
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.surface.modal};
  border: 1px solid ${({ theme }) => theme.colors.border.surface};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  box-shadow: ${({ theme }) => theme.shadows.surface};
  gap: ${({ theme }) => theme.spacing["2"]};
  justify-content: flex-start;
  padding: ${({ theme }) =>
    `${theme.spacing["4"]} ${theme.spacing["4"]} ${theme.spacing["4"]} ${theme.spacing["6"]}`};
`;

const StyledSButton = styled(MDSButton)`
  width: 122.333px;
`;
